class SingleNews {
	constructor() {
		this.singleNews = document.querySelector(".single-news");
		if (!this.singleNews) {
			return;
		}

		this.buildGallery();
	}

	buildGallery() {
		document.querySelectorAll('.gallery-four').forEach(item => {
			lightGallery(item, {
				speed: 500,
				selector: "a",
				zoomFromOrigin: false,
				licenseKey: '0000-0000-000-0001',
				getCaptionFromTitleOrAlt: true,
			});
		});


		document.querySelectorAll('.gallery-three').forEach(item => {
			lightGallery(item, {
				speed: 500,
				selector: "a",
				zoomFromOrigin: false,
				licenseKey: '0000-0000-000-0001',
				getCaptionFromTitleOrAlt: true,
			});
		});

		document.querySelectorAll('.block-two_col_img').forEach(item => {
			lightGallery(item, {
				speed: 500,
				selector: "a",
				zoomFromOrigin: false,
				licenseKey: '0000-0000-000-0001',
				getCaptionFromTitleOrAlt: true,
			});
		});


	}
}